<template>
	<page :loading="loading">
		<div slot="header" class="flex-row">
			<div class="flex-item page_header">
				<el-form size="small" :inline="true">
					<el-form-item label="保单号">
						<el-input v-model="table.search.policy_no" placeholder="请输入保单号" clearable>
						</el-input>
					</el-form-item>
					<el-form-item label="投保人">
						<el-input v-model="table.search.applicant_info" placeholder="请输入投保人信息" clearable>
						</el-input>
					</el-form-item>
					<el-form-item label="被保人">
						<el-input v-model="table.search.insured_info" placeholder="请输入被保人信息" clearable>
						</el-input>
					</el-form-item>
					<el-form-item label="订单状态">
						<el-select clearable v-model="table.search.status" placeholder="请选择" clearable>
							<el-option :value="0" label="待支付"></el-option>
							<el-option :value="1" label="待生效"></el-option>
							<el-option :value="2" label="生效中"></el-option>
							<el-option :value="3" label="已结束"></el-option>
							<el-option :value="4" label="已退保"></el-option>
						</el-select>
					</el-form-item>
					<!-- 新增的筛选字段 -->
					<el-form-item label="保险产品">
						<el-input v-model="table.search.goods_name" placeholder="请输入保险产品" clearable/>
					</el-form-item>
					<el-form-item label="团队长">
						<el-select-search v-model="table.search.user_pid" api="getTeam" lakey="id" label="nickname" clearable placeholder="请输入手机号/昵称/ID"/>
					</el-form-item>
					<el-form-item label="承保公司">
						<el-input v-model="table.search.insurer_name" placeholder="请输入承保公司" clearable/>
					</el-form-item>
					<!-- <el-form-item label="发票状态">
						<el-select clearable v-model="table.search.invoice_status" placeholder="请选择" clearable>
							<el-option :value="0" label="未申请"></el-option>
							<el-option :value="1" label="申请中"></el-option>
							<el-option :value="2" label="已开票"></el-option>
						</el-select>
					</el-form-item> -->
					<!-- <el-form-item label="支付时间">
						<el-date-picker v-model="table.search.payment_time_range" type="daterange" range-separator="至"
							start-placeholder="开始日期" end-placeholder="结束日期" value-format="yyyy-MM-dd" size="small">
						</el-date-picker>
					</el-form-item> -->
					<!-- 新增的保险期间筛选 -->
					<el-form-item label="保险起期">
						<el-date-picker v-model="table.search.pln_start_date_range" type="daterange" range-separator="至"
							start-placeholder="开始日期" end-placeholder="结束日期" value-format="yyyy-MM-dd" size="small">
						</el-date-picker>
					</el-form-item>
					<el-form-item label="保险止期">
						<el-date-picker v-model="table.search.pln_end_date_range" type="daterange" range-separator="至"
							start-placeholder="开始日期" end-placeholder="结束日期" value-format="yyyy-MM-dd" size="small">
						</el-date-picker>
					</el-form-item>
					<el-form-item>
						<el-button size="small" type="primary" plain @click="LoadDatas(1,20)">
							查询
						</el-button>
						<el-button size="small" type="info" plain @click="reset">
							重置
						</el-button>
						<el-button size="small" type="success" plain @click="exportExcel" :loading="exportLoading">
							导出Excel
						</el-button>
					</el-form-item>
				</el-form>
			</div>
		</div>

		<page-table @sortChange="sortChange" :datas="table.data" :page="table.search._page" :size="table.search._size"
			:total="table._count" @change="LoadDatas">
			<el-table-column prop="id" label="订单ID" align="center" fixed="left" width="120" />
			<el-table-column prop='order_no' label='订单号' align='center' width="200" />
			<el-table-column prop='policy_no' label='保单号' align='center' width="200" />
			<el-table-column label="保险产品" show-overflow-tooltip width="200">
				<template slot-scope="scope">
					<div class="goods">
						<div class="goods-name">{{ scope.row.goods_name || '-' }}</div>
						<div class="goods-specs">{{ scope.row.goods_specs_name || '-' }} -
							¥{{ scope.row.goods_specs_price || '0.00' }}</div>
					</div>
				</template>
			</el-table-column>
			<el-table-column prop="insurer_name" label="承保公司" align="center" width="200" />
			<el-table-column label="投保人信息" align="center" show-overflow-tooltip width="200">
				<template slot-scope="scope">
					<div v-if="getApplicantInfo(scope.row.applicant_info)">
						<div>{{ getApplicantInfo(scope.row.applicant_info).applicant_name || '-' }}</div>
						<div>{{ getApplicantInfo(scope.row.applicant_info).applicant_phone || '-' }}</div>
						<div class="applicant-type">
							{{ getApplicantInfo(scope.row.applicant_info).applicant_type === 0 ? '个人' : 
							  getApplicantInfo(scope.row.applicant_info).applicant_type === 1 ? '企业' : '-' }}
						</div>
					</div>
					<div v-else class="no-data">-</div>
				</template>
			</el-table-column>
			<el-table-column prop='amount' label='保单金额' align='center' />
			<el-table-column label="保险期间" align="center" show-overflow-tooltip width="180">
				<template slot-scope="scope">
					<div>{{ scope.row.pln_start_date || '-' }}</div>
					<div>至</div>
					<div>{{ scope.row.pln_end_date || '-' }}</div>
					<div>({{ scope.row.insured_days || 0 }}天)</div>
				</template>
			</el-table-column>
			<el-table-column prop='insuredCount' label='被保人数' align='center' width="100" />
			<el-table-column label="订单状态" align="center" show-overflow-tooltip width="120">
				<template slot-scope="scope">
					<div>{{ scope.row.statusText || '-' }}</div>
					<div class="invoice" v-if="scope.row.invoice_status == 1">待开票</div>
					<div class="refund" v-if="scope.row.refund_status == 1">售后中</div>
				</template>
			</el-table-column>
			<el-table-column prop='payment_time' label='支付时间' align='center' width="180" />
			<el-table-column prop='created_at' label='下单时间' align='center' width="180" />
			<el-table-column label="操作" align="center" fixed="right" width="150">
				<template slot-scope="scope">
					<el-popover placement="bottom" width="120" trigger="click">
						<div class="btn" @click="info = scope.row, showDrawer = true">详情</div>
						<!-- <div class="btn" @click="openRefundDialog(scope.row)" v-if="scope.row.status >= 1 && scope.row.status <= 3 && scope.row.refund_status == 0">
							发起退保
						</div> -->
						<div class="btn" @click="openClaimApply(scope.row)" v-if="scope.row.status == 3">理赔申请</div>
						<div class="btn" @click="info = scope.row, remarkDialog = true">保单备注</div>
						<!-- <div class="btn" @click="updateInvoiceStatus(scope.row)" v-if="scope.row.invoice_status == 1">
							标记已开票
						</div> -->
						<el-button slot="reference" type="text" size="small">更多</el-button>
					</el-popover>
				</template>
			</el-table-column>
		</page-table>

		<el-drawer :modal="false" v-if="showDrawer" title="保单信息" size="50%" :visible.sync="showDrawer">
			<info @save="save()" @cancel="showDrawer = false" :id="info.id" />
		</el-drawer>

		<el-dialog width="40%" title="后台保单备注" :visible.sync="remarkDialog">
			<el-form label-width="100px">
				<el-form-item label="后台保单备注">
					<el-col :span="20">
						<el-input type="textarea" :rows="4" :maxlength="120" clearable v-model="info.admin_remark"
							placeholder="订单备注" />
					</el-col>
				</el-form-item>
			</el-form>
			<div slot="footer" class="dialog-footer">
				<el-button @click="remarkDialog = false">取 消</el-button>
				<el-button type="primary"
					@click="ActionSave({id: info.id, admin_remark: info.admin_remark}), remarkDialog = false">
					确认修改
				</el-button>
			</div>
		</el-dialog>

		<el-dialog width="50%" title="发起退保" :visible.sync="refundDialog">
			<el-descriptions :column="2" border>
				<el-descriptions-item label="保单金额">{{ info.amount || '0.00' }}</el-descriptions-item>
				<el-descriptions-item label="保险产品">{{ info.goods_name || '-' }}</el-descriptions-item>
				<el-descriptions-item label="保险期间" :span="2">
					{{ info.pln_start_date || '-' }} 至 {{ info.pln_end_date || '-' }}
				</el-descriptions-item>
				<el-descriptions-item label="投保人">
					{{ getApplicantInfo(info.applicant_info) ? getApplicantInfo(info.applicant_info).applicant_name : '-' }}
				</el-descriptions-item>
				<el-descriptions-item label="联系电话">
					{{ getApplicantInfo(info.applicant_info) ? getApplicantInfo(info.applicant_info).applicant_phone : '-' }}
				</el-descriptions-item>
			</el-descriptions>
			<el-form style="margin-top: 20px;">
				<el-form-item label="退保原因">
					<el-col :span="20">
						<el-input type="textarea" :rows="4" :maxlength="120" clearable v-model="info.reason"
							placeholder="请输入退保原因" />
					</el-col>
				</el-form-item>
			</el-form>
			<div slot="footer" class="dialog-footer">
				<el-button @click="refundDialog = false">取消</el-button>
				<el-button type="primary" @click="createRefundOrder" :disabled="disabled">
					确认退保
				</el-button>
			</div>
		</el-dialog>

		<el-drawer :modal="false" size="50%" title="理赔申请" :visible.sync="claimApplyDialog">
			<claim-apply v-if="claimApplyDialog" :order-id="selectedOrderId" @success="onClaimApplySuccess"
				@cancel="onClaimApplyCancel" />
		</el-drawer>
	</page>
</template>
<script>
	import info from '../component/info.vue';
	import claimApply from '../component/claimApply.vue';
	export default {
		components: {
			info,
			claimApply,
		},
		data() {
			return {
				loading: false,
				exportLoading: false, // 导出加载状态
				table: {
					data: [],
					form: {},
					search: {
						_page: 1,
						_size: 20,
						_order: 'id',
						_isreverse: 1, // 是否倒序 0否 1是（默认1）
						payment_time_range: [],
						pln_start_date_range: [], // 新增：保险起期范围
						pln_end_date_range: [], // 新增：保险止期范围
						goods_name: '', // 新增：保险产品
						insurer_name: '', // 新增：承保公司
					},
					_count: 0,
				},
				showDrawer: false,
				info: {},
				remarkDialog: false,
				refundDialog: false,
				disabled: false,
				claimApplyDialog: false,
				selectedOrderId: null
			}
		},
		mounted() {
			this.LoadDatas();
		},
		methods: {
			// 导出Excel
			async exportExcel() {
				this.exportLoading = true;
				try {
					// 构建导出参数
					const exportParams = this.$buildExportParams(this.table.search);

					// 处理支付时间范围
					if (exportParams.payment_time_range && exportParams.payment_time_range.length === 2) {
						exportParams.payment_timestart = exportParams.payment_time_range[0] + ' 00:00:00';
						exportParams.payment_timeend = exportParams.payment_time_range[1] + ' 23:59:59';
						delete exportParams.payment_time_range;
					}

					// 处理保险起期范围
					if (exportParams.pln_start_date_range && exportParams.pln_start_date_range.length === 2) {
						exportParams.pln_start_datestart = exportParams.pln_start_date_range[0] + ' 00:00:00';
						exportParams.pln_start_dateend = exportParams.pln_start_date_range[1] + ' 23:59:59';
						delete exportParams.pln_start_date_range;
					}

					// 处理保险止期范围
					if (exportParams.pln_end_date_range && exportParams.pln_end_date_range.length === 2) {
						exportParams.pln_end_datestart = exportParams.pln_end_date_range[0] + ' 00:00:00';
						exportParams.pln_end_dateend = exportParams.pln_end_date_range[1] + ' 23:59:59';
						delete exportParams.pln_end_date_range;
					}

					// 调用导出
					await this.$export('orderExport', exportParams, '保单列表');
				} catch (error) {
					this.$message.warning(error);
				} finally {
					this.exportLoading = false;
				}
			},

			// 打开理赔申请
			openClaimApply(order) {
				this.selectedOrderId = order.id;
				this.claimApplyDialog = true;
			},

			// 理赔申请成功
			onClaimApplySuccess() {
				this.claimApplyDialog = false;
				this.LoadDatas(); // 刷新列表
			},

			// 理赔申请取消
			onClaimApplyCancel() {
				this.claimApplyDialog = false;
			},

			// 安全解析投保人信息
			getApplicantInfo(applicantInfo) {
				if (!applicantInfo) {
					return null;
				}
				try {
					if (typeof applicantInfo === 'string') {
						const parsed = JSON.parse(applicantInfo);
						return parsed || null;
					} else if (typeof applicantInfo === 'object') {
						return applicantInfo;
					}
					return null;
				} catch (error) {
					return null;
				}
			},

			createRefundOrder() {
				if (!this.info.reason) {
					return this.$warning('请输入退保原因');
				}
				if (this.disabled) {
					return;
				}
				this.disabled = true;

				let refundData = {
					order_id: this.info.id,
					order_no: this.info.order_no,
					reason: this.info.reason,
					reason_type: '后台发起退保',
				};

				this.$post('createRefundOrder', refundData).then(res => {
					this.$success('退保申请提交成功');
					this.refundDialog = false;
					this.reset();
				}).catch(err => {
					this.disabled = false;
					this.$warning(err);
				})
			},
			openRefundDialog(info) {
				this.info = info;
				this.refundDialog = true;
				this.info.reason = '';
			},
			updateInvoiceStatus(info) {
				this.$confirm('确认标记为已开票吗？', '提示', {
					confirmButtonText: '确定',
					cancelButtonText: '取消',
					type: 'warning'
				}).then(() => {
					this.ActionSave({
						id: info.id,
						invoice_status: 2
					});
				});
			},
			save() {
				this.showDrawer = false;
				this.info = {};
				this.reset();
			},
			reset() {
				this.table.search = {
					_page: 1,
					_size: 20,
					_order: '',
					_isreverse: 1,
					payment_time_range: [],
					pln_start_date_range: [], // 重置
					pln_end_date_range: [], // 重置
					goods_name: '', // 重置
					insurer_name: '', // 重置
				};
				this.LoadDatas();
			},
			sortChange(e) {
				var isreverse = 1;
				if (e.order == null) {
					this.reset();
				} else if (e.order == 'descending') {
					var isreverse = 1;
				} else if (e.order == 'ascending') {
					var isreverse = 0;
				}
				this.table.search = {
					_page: 1,
					_size: 20,
					_order: e.prop,
					_isreverse: isreverse,
					payment_time_range: this.table.search.payment_time_range,
					pln_start_date_range: this.table.search.pln_start_date_range,
					pln_end_date_range: this.table.search.pln_end_date_range,
					goods_name: this.table.search.goods_name,
					insurer_name: this.table.search.insurer_name,
				};
				this.LoadDatas();
			},
			/**
			 * 获取数据列表
			 * @param page 分页-当前页
			 * @param size 分页-每页数量
			 * **/
			LoadDatas(page, size) {
				page && (this.table.search._page = page), size && (this.table.search._size = size);

				// 处理支付时间范围
				let searchParams = {
					...this.table.search
				};
				
				// 处理支付时间范围
				if (searchParams.payment_time_range && searchParams.payment_time_range.length === 2) {
					searchParams.payment_timestart = searchParams.payment_time_range[0] + ' 00:00:00';
					searchParams.payment_timeend = searchParams.payment_time_range[1] + ' 23:59:59';
					delete searchParams.payment_time_range;
				}

				// 处理保险起期范围
				if (searchParams.pln_start_date_range && searchParams.pln_start_date_range.length === 2) {
					searchParams.pln_start_datestart = searchParams.pln_start_date_range[0] + ' 00:00:00';
					searchParams.pln_start_dateend = searchParams.pln_start_date_range[1] + ' 23:59:59';
					delete searchParams.pln_start_date_range;
				}

				// 处理保险止期范围
				if (searchParams.pln_end_date_range && searchParams.pln_end_date_range.length === 2) {
					searchParams.pln_end_datestart = searchParams.pln_end_date_range[0] + ' 00:00:00';
					searchParams.pln_end_dateend = searchParams.pln_end_date_range[1] + ' 23:59:59';
					delete searchParams.pln_end_date_range;
				}

				// 处理关键字搜索
				if (searchParams.keyword) {
					searchParams.policy_no = searchParams.keyword;
					searchParams.applicant_info = searchParams.keyword;
					delete searchParams.keyword;
				}

				this.loading = true;
				this.$get('app-order', searchParams).then(res => {
					this.table.data = res.data;
					this.table._count = res.extra.pageInfo.count;
					this.loading = false;
				}).catch(err => {
					this.$notify.error({
						message: err || '网络请求错误'
					});
					this.loading = false;
				});
			},
			ActionSave(data) {
				this.$load();
				this.$save('app-order', data).then(res => {
					this.reset();
					this.$success('操作成功');
				}).catch(err => {
					this.$warning(err);
					this.$load(false);
				});
			},
		},
	}
</script>

<style lang="scss" scoped>
	.page_header {
		margin: 10px 10px 0;
		position: absolute;
		z-index: 100;
	}

	.refund {
		color: #ff4b14;
	}

	.invoice {
		color: #0841ff;
	}

	.btn {
		cursor: pointer;
		width: 100%;
		padding: 5px;
		font-size: 12px;
	}

	.btn:hover {
		background-color: #ecf3fd;
		color: #3E84E9;
	}

	.goods {
		.goods-name {
			font-weight: bold;
			margin-bottom: 5px;
		}

		.goods-specs {
			font-size: 12px;
			color: #666;
		}
	}

	.applicant-type {
		font-size: 12px;
		color: #999;
		margin-top: 2px;
	}

	.no-data {
		color: #999;
		font-style: italic;
	}

	.el-descriptions {
		margin-bottom: 15px;
	}
</style>